<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Novo Identificador
        </span>
      </h3>
    </div>
    <Form url="/identificador/create" :identificador="identificador" />
  </div>
</template>

<script>
import Form from "./Form.vue";
import IdentificadorData from "./IdentificadorData";
import { mapGetters } from "vuex";

export default {
  name: "app-identificador-create",
  data() {
    return {
      identificador: new IdentificadorData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>
